import styled from "styled-components";
import { FileCard } from "common/components/organisms/files/FileCard";
import { Badge } from "react-bootstrap";
import { TasksByTaskType } from "pages/print/types/TasksByTaskType";
import { toFormattedDate } from "utils/DateTools";
import { DateAndPictures } from "pages/print/types/PrintTasksRequestInfo";
import React from "react";

type Props = {
  task: TasksByTaskType; // used to extract date
  selecteds: DateAndPictures[];
  selectionChanged: (selecteds: DateAndPictures[]) => void;
};

export const SelectPicturesPanel = (props: Props) => {
  const { task, selecteds, selectionChanged } = props;

  const getSelectedNumber = (fileId: number, date: Date): number | undefined => {
    const taskIndex = task.tasks.findIndex(
      (x) => x.record.pictures.findIndex((y) => y.fileId === fileId) >= 0
    );
    const target = selecteds[taskIndex]; //.find((x) => x.date === date);
    const idx = target?.pictures.findIndex((x) => x === fileId) ?? -1;
    if (idx < 0) return undefined;
    return idx + 1;
  };

  const pictClicked = (fileId: number, date: Date) => {
    const target = selecteds.find((x) => x.date === date);
    const idx = target?.pictures.findIndex((x) => x === fileId) ?? -1;

    const unselect = idx >= 0;
    if (unselect) {
      if (!target) return; // 起きない

      // 選択 → 非選択
      target.pictures = target.pictures.filter((x) => x !== fileId);
    } else {
      // 非選択 → 選択
      if (!target) selecteds.push({ date, pictures: [] });
      else {
        target.pictures.push(fileId);
      }
    }
    selectionChanged(selecteds);
  };

  return (
    <SRootDiv>
      {task.tasks.map((aTask, index) =>
        aTask.record.pictures.length === 0 ? (
          <React.Fragment key={`empty_${aTask.date.toString()}_${index}`}></React.Fragment>
        ) : (
          // 日付ごとに出力
          <div key={`taskDate_${aTask.date.toString()}_${index}`}>
            <h5>{toFormattedDate(new Date(aTask.date))}</h5>
            <SRow>
              {aTask.record.pictures.map((file) => (
                <SDiv
                  key={`pict_${file.fileId}`}
                  className={`${
                    getSelectedNumber(file.fileId, aTask.date) !== undefined ? "selected" : ""
                  }`}
                  onClick={() => pictClicked(file.fileId, aTask.date)}
                >
                  <SBadge bg="info">{getSelectedNumber(file.fileId, aTask.date)}</SBadge>
                  <FileCard
                    key={`task_pict_${file.fileId}`}
                    file={file}
                    imgHeight="7rem"
                    cardWidth="14rem"
                    showPicture={true}
                    canDownload={false}
                    readOnly={true}
                  />
                </SDiv>
              ))}
            </SRow>
          </div>
        )
      )}
    </SRootDiv>
  );
};

const SRootDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
`;
const SDiv = styled.div`
  position: relative;
  cursor: pointer;
  &.selected {
    .card {
      border: 2px solid orange !important;
      border-radius: 8px;
    }
  }
`;

const SBadge = styled(Badge)`
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 1;
`;
